module.exports = __webpack_public_path__ + "media/images/emblems/Duebendorf-blazon-591025b81d7304955f5e7ab196a7c67b.svg";